import { memo } from 'react';

import ErrorBoundary from '~/components/shared/Errors/ErrorBoundary';
import type { PromotedContestCarousel } from '~/services/marketing/promoted-contests.schema';

import type { HomeCollectionSlug } from '../../constants/query';

import { CondensedCarouselView } from './CondensedCarouselView';
import { useCondensedCarouselModule } from './useCondensedCarouselModule';

type CondensedCarouselModuleProps = {
  slug: HomeCollectionSlug;
  carousel: PromotedContestCarousel;
};

function ModuleContent({ slug, carousel }: CondensedCarouselModuleProps) {
  const view = useCondensedCarouselModule({ slug, carousel });

  return <CondensedCarouselView {...view} title={carousel.title} iconUrl={carousel.iconUrl} />;
}

export const CondensedCarouselModule = memo(({ slug, carousel }: CondensedCarouselModuleProps) => (
  <ErrorBoundary FallbackComponent={null}>
    <ModuleContent slug={slug} carousel={carousel} />
  </ErrorBoundary>
));
CondensedCarouselModule.displayName = 'CondensedCarouselModule';
